import moment from "moment";
import "./style.less";
export default function UserBookingPeriod() {
    return {
        restrict: "E",
        scope: {
            bp: "=",
            color: "@",
        },
        transclude: true,
        template: require("./template.html"),

        controller: function ($scope, $route, BpCancelationModalFactory, ENV) {
            $scope.env = angular.copy(ENV);
            $scope.isFutureBp = moment() < moment($scope.bp.start);
            // console.log(
            //     moment($scope.bp.start).format() +
            //         " - Future : ? " +
            //         $scope.isFutureBp
            // );

            const eSum = (bpEntries) => {
                // var total = 0; // reset and recalculate total price
                let total = 0;

                bpEntries.forEach((bpe) => {
                    total += bpe.price * bpe.amount;
                });

                return total;
            };

            const entriesSum = $scope.bp.bookingPeriodEntries
                ? eSum($scope.bp.bookingPeriodEntries)
                : 0;

            $scope.totalPrice = $scope.bp.price + entriesSum;

            $scope.cancelBooking = function (bp, color) {
                $scope.showCancelationModal(bp, color);
            };

            // $scope.toggleObj = function (obj) {
            //     obj._isOpen = !obj._isOpen;
            // };

            $scope.showCancelationModal = (bp, color) => {
                BpCancelationModalFactory.modal(bp, color).then(
                    (res) => {
                        if (res.bpWasCancelled) {
                            // console.log(
                            //     "Update bp status + render new total price"
                            // );

                            $route.reload();
                            // TO DO ::: MEDIUM ::: Update the booking changes (cancelled and new PDF etc...)
                            // bookingService
                            //     .getBookings()
                            //     .then(function (bookings) {
                            //         userBookingsFactory.processBookings(
                            //             bookings
                            //         );
                            //     });
                        }
                    },
                    (error) => {
                        // error contains a detailed error message.
                        console.warn(error);
                    }
                );
            };
        },
    };
}
